"use client"

import { useEffect } from "react"
import { trackViewVehicle, trackViewContactPage } from "@/lib/gtag"

type TrackPageViewProps = {
  type: "vehicle" | "contact"
  vehicleSlug?: string
}

export default function TrackPageView({ type, vehicleSlug }: TrackPageViewProps) {
  useEffect(() => {
    if (type === "vehicle" && vehicleSlug) {
      trackViewVehicle(vehicleSlug)
    } else if (type === "contact") {
      trackViewContactPage()
    }
  }, [type, vehicleSlug])

  return null
}
